import { ControlUnitAPIResponse } from '../../../redux/controlUnit/api/ControlUnit.model';
import ControlUnitAPI from '../../../redux/controlUnit/api/ControlUnitAPI';
import {
  getControlUnitsActiveByIdFilter,
  getControlUnitsVisibleByIdFilter,
} from '../../../redux/controlUnit/selectors';
import { Merchandiser } from '../redux/composableDevice/model/Merchandiser.model';

export const useGetValidControlUnits = (merchandiser: Merchandiser) => {
  const serialNumber =
    merchandiser?.composableDevice?.labels?.serial_number || '';
  const controlUnits = ControlUnitAPI.useGetControlUnitsBySerialNumberQuery(
    serialNumber,
    {
      skip: !serialNumber,
    }
  );
  const validControlUnits =
    controlUnits?.data?.filter(
      (cu: ControlUnitAPIResponse) =>
        getControlUnitsActiveByIdFilter(cu) &&
        getControlUnitsVisibleByIdFilter(cu)
    ) || [];
  return validControlUnits;
};
